import Rails from "rails-ujs";
Rails.start();

import Turbolinks from "turbolinks";
Turbolinks.start();
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.ja'

// JS
import 'jquery';
global.$ = global.jQuery = jQuery
window.$ = window.jQuery = jQuery

// CSS
import "../src/application.scss";

// js
import './trademark';
import './order';
import './common/message_attachment';

//
// common behaviors
//
import './common/toastr';

// 日付選択フィールドでカレンダーを表示する
$(document).on('turbolinks:load', function() {
  $('.form-control-datepicker').datepicker({
    format: "yyyy-mm-dd",
    language: 'ja',
    autoclose: true,
    maxViewMode: 'days'
  })
})

//
// プロフィール編集画面でパスワードを変更するかどうかのチェックボックスで
// 入力フォームの表示を切り替える
//
$(document).on("turbolinks:load", function() {
  $(".change-password").on("change", function() {
    if ($(this).is(":checked")) {
      $(".form-group-password").removeClass("d-none");
    } else {
      $(".form-group-password").addClass("d-none");
    }
  });
});
